
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="card-wrapper type-modal" [formGroup]="newOrganizationForm">
    <div class="card !pb-4">
      <h3 class="green decoration mb-4">Detalles de la sucursal</h3>

      <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('name_branch_office').dirty && newOrganizationForm.get('name_branch_office').invalid">
        <span>Nombre de la sucursal:</span>
        <input type="text" formControlName="name_branch_office" placeholder="Ej: Sucursal 1" [attr.disabled]="true">
        <p *ngIf="newOrganizationForm.get('name_branch_office').dirty && newOrganizationForm.get('name_branch_office').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('name_branch_office').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('city').dirty && newOrganizationForm.get('city').invalid">
        <span>Ciudad:</span>
        <select formControlName="city" (change)="getZones()" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let city of cities" [value]="city.id">{{ city.name }}</option>
        </select>
        <p *ngIf="newOrganizationForm.get('city').dirty && newOrganizationForm.get('city').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('city').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('zone_id').dirty && newOrganizationForm.get('zone_id').invalid">
        <span>Zona:</span>
        <select formControlName="zone_id" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let zone of zones" [value]="zone.id">{{ zone.name }}</option>
        </select>
        <p *ngIf="newOrganizationForm.get('zone_id').dirty && newOrganizationForm.get('zone_id').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('zone_id').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <!-- <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('type_br').dirty && newOrganizationForm.get('type_br').invalid">
        <span>Tipo de sucursal:</span>
        <select formControlName="type_br" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let branch_types of branchs_types" [value]="branch_types.value">{{ branch_types.name }}</option>
        </select>
        <p *ngIf="newOrganizationForm.get('type_br').dirty && newOrganizationForm.get('type_br').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('type_br').errors.required">Este campo es necesario</label>
        </p>
      </div> -->
      <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('address').dirty && newOrganizationForm.get('address').invalid">
        <span>Calle:</span>
        <input type="text" placeholder="Ej: 25" formControlName="address" [attr.disabled]="true">
        <p *ngIf="newOrganizationForm.get('address').dirty && newOrganizationForm.get('address').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('address').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
    <div class="card !pb-4">
      <h3 class="green" style="margin-bottom: 1.6rem;">&nbsp;</h3>
      <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('house_number').dirty && newOrganizationForm.get('house_number').invalid">
        <span>N. de Casa:</span>
        <input type="number" placeholder="Ej: 444" formControlName="house_number" [attr.disabled]="true">
        <p *ngIf="newOrganizationForm.get('house_number').dirty && newOrganizationForm.get('house_number').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('house_number').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <!-- <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('status').dirty && newOrganizationForm.get('status').invalid">
        <span>Estado:</span>
        <select formControlName="status" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let statusItem of status" [value]="statusItem.value">{{ statusItem.name }}</option>
        </select>
        <p *ngIf="newOrganizationForm.get('status').dirty && newOrganizationForm.get('status').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('status').errors.required">Este campo es necesario</label>
        </p>
      </div> -->
      <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('cost_center_name').dirty && newOrganizationForm.get('cost_center_name').invalid">
        <span>Nombre del centro de costo:</span>
        <input type="text" formControlName="cost_center_name" placeholder="Ej: Centro 22" [attr.disabled]="true">
        <p *ngIf="newOrganizationForm.get('cost_center_name').dirty && newOrganizationForm.get('cost_center_name').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('cost_center_name').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newOrganizationForm.get('cost_center_code').dirty && newOrganizationForm.get('cost_center_code').invalid">
        <span>Código del centro de costo:</span>
        <input type="text" formControlName="cost_center_code" placeholder="Ej: cntr-22" [attr.disabled]="true">
        <p *ngIf="newOrganizationForm.get('cost_center_code').dirty && newOrganizationForm.get('cost_center_code').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newOrganizationForm.get('cost_center_code').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
    <div class="px-6 pb-6 w-full" *ngIf="data?.map">
      <div class="form-wrapper">
        <span>Mapa:</span>
        <div class="map-container">
          <app-google-maps [htmlId]="'modal-map'" [createBraanchApart]="true" [latLong2]="data?.map || ''" (eventSendCoord)="setCoords($event)" [editable]="false"></app-google-maps>
        </div>
        <p *ngIf="coords == undefined && mapTouched">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label>Este campo es necesario</label>
        </p>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <!-- <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
